import request from '@/utils/request';

// 1. 获取标签列表
export function fetchTagList(params) {
  return request({
    url: '/ajax/system/tags',
    method: 'get',
    params: params || {
      page: 1,
      size: 99
    }
  });
}

// 2. 获取标签信息
export function fetchTagInfo(appTagId) {
  return request({
    url: '/ajax/system/tag/' + appTagId,
    method: 'get'
  });
}

// 3. 编辑标签信息
export function updateTagInfo(data) {
  return request({
    url: '/ajax/system/tag',
    method: 'PUT',
    data: data
  });
}

// 4. 新增标签信息
export function addTagInfo(data) {
  return request({
    url: '/ajax/system/tag',
    method: 'post',
    data: data
  });
}


// 5. 删除标签
export function deleteTag(appTagId) {
  return request({
    url: '/ajax/system/tag/' + appTagId,
    method: 'DELETE',
    data: { appTagId }
  });
}

// 6. 标签排序
export function upDateSorting(data) {
  return request({
    url: '/ajax/system/reverse-tags',
    method: 'post',
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/api/label.js